import React, { useCallback, useEffect, useState } from "react";
import { CloseIcon } from "@/assets/svgs/icons";


interface AnswerEditorProps {
    disalbed?: boolean;
    defaultAnswers?: string[];
    updateAnswers: (answers: string[]) => void;
}

const AnswerEditor: React.FC<AnswerEditorProps> = (props) => {
    const { defaultAnswers: propsAnswers, updateAnswers, disalbed } = props;

    const [answers, setAnswers] = useState<string[]>([]);

    const handleChange = useCallback((newAnswers: string[]) => {
        setAnswers(newAnswers);
        updateAnswers(newAnswers);
    }, [updateAnswers]);

    const onChangeAnswer = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        handleChange([
            ...answers.slice(0, index),
            e.target.value,
            ...answers.slice(index + 1)
        ]);
    };

    const onClickDeleteAnswer = (index: number) => {
        handleChange([
            ...answers.slice(0, index),
            ...answers.slice(index + 1)
        ]);
    };

    const onKeyDownEnter = (e: React.FormEvent, index: number) => {
        e.preventDefault();
        if (answers!.length !== index + 1 || answers!.length >= 5) {
            return;
        }

        handleChange([...answers, ""]);
        setTimeout(() => {
            document.getElementById(`answer-edit-input-${index + 1}`)?.focus();
        }, 0);
    };

    useEffect(() => {
        if (propsAnswers?.length === 5) {
            handleChange(propsAnswers);
        } else {
            handleChange([...(propsAnswers ?? []), ""]);
        }
    }, [propsAnswers, handleChange]);

    return (
        <div className="flex flex-col gap-1">
            {answers?.slice(0, 5).map((answer, i) => (
                <form key={i}
                      className="relative flex items-center gap-1.5"
                      onSubmit={e => onKeyDownEnter(e, i)}
                >
                    <input id={`answer-edit-input-${i}`}
                           type="text"
                           disabled={disalbed}
                           className="input-default"
                           value={answer}
                           onChange={e => onChangeAnswer(e, i)}
                    />
                    {answers.length > 1 && (
                        <button type="button"
                                className="absolute right-2.5"
                                onClick={() => onClickDeleteAnswer(i)}
                        >
                            <CloseIcon className="size-4" />
                        </button>
                    )}
                </form>
            ))}
        </div>
    );
};

export default AnswerEditor;
